import { catalogApiFetch } from '../admin/jscontrol/apiClient';
import { getImageSrc } from './appConfig';
import { fetchProductImage, parseApiList } from './productStorefront';

const isActiveBundle = (bundle) => {
  const active = bundle?.IsActive ?? bundle?.isActive;
  if (active === undefined || active === null) return true;
  return active === true || active === 1 || String(active).toLowerCase() === 'true';
};

const relationProductId = (row) => Number(row.ProductId ?? row.productId);
const relationBundleId = (row) => Number(row.BundleProductId ?? row.bundleProductId);

const mapRelationProduct = async (rel) => {
  const productId = relationProductId(rel);
  const imageSrc = await fetchProductImage(productId);
  return {
    id: productId,
    name: rel.ProductName ?? rel.productName ?? '',
    price: rel.Price != null ? Number(rel.Price) : 0,
    imageSrc: imageSrc || getImageSrc(''),
  };
};

const fetchRelationsForBundle = async (bundleProductId) => {
  const params = new URLSearchParams({
    pageIndex: '1',
    pageSize: '50',
    bundleProductId: String(bundleProductId),
  });
  const { data } = await catalogApiFetch(`/BundleProductRelation/GetAll?${params}`);
  return parseApiList(data);
};

export const fetchBundleRelationCount = async (bundleProductId) => {
  const id = Number(bundleProductId);
  if (!Number.isFinite(id) || id <= 0) return 0;
  try {
    const relations = await fetchRelationsForBundle(id);
    return relations.length;
  } catch {
    return 0;
  }
};

const fetchRelationsForProduct = async (productId) => {
  try {
    const { data } = await catalogApiFetch(`/BundleProductRelation/GetByProductId/${productId}`);
    return parseApiList(data);
  } catch {
    const params = new URLSearchParams({
      pageIndex: '1',
      pageSize: '50',
      productId: String(productId),
    });
    const { data } = await catalogApiFetch(`/BundleProductRelation/GetAll?${params}`);
    return parseApiList(data);
  }
};

/** Bundles only for products linked in dbo.BundleProductRelations (by ProductId). */
export const fetchBundlesForProduct = async (productId) => {
  const id = Number(productId);
  if (!Number.isFinite(id) || id <= 0) return [];

  try {
    const productRelations = (await fetchRelationsForProduct(id))
      .filter((row) => relationProductId(row) === id);

    if (!productRelations.length) return [];

    const bundleIds = [...new Set(
      productRelations.map(relationBundleId).filter((bundleId) => bundleId > 0)
    )];

    const bundles = await Promise.all(bundleIds.map(async (bundleProductId) => {
      const { data: bundleRes } = await catalogApiFetch(`/BundleProduct/GetById/${bundleProductId}`);
      const bundle = bundleRes?.data ?? bundleRes;
      if (!bundle?.BundleProductId || !isActiveBundle(bundle)) return null;

      const relations = await fetchRelationsForBundle(bundleProductId);
      if (relations.length < 2) return null;

      const products = await Promise.all(relations.map(mapRelationProduct));
      if (!products.some((item) => item.id === id)) return null;

      const itemsTotal = products.reduce((sum, item) => sum + item.price, 0);
      const bundlePrice = bundle.Price != null ? Number(bundle.Price) : 0;

      return {
        bundleProductId,
        name: bundle.ProductName ?? bundle.productName ?? '',
        price: bundlePrice > 0 ? bundlePrice : itemsTotal,
        products,
      };
    }));

    return bundles.filter(Boolean);
  } catch {
    return [];
  }
};
